import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    this.patternMask = IMask(this.element, {
      mask: '+{1} (000) 000-0000',
      //Use to show mask when the component loads with data in it. Usually when an error occurs
      lazy: !this.element.value
    })

    //when you click on input, placeholders are shown
    this.element.addEventListener('focus', this.onFocus, true)
    //when click off, hide placeholders if input is empty
    this.element.addEventListener('blur', this.onBlur, true)

    document.addEventListener('turbo:morph', this.updateMaskValue)
    document.addEventListener('turbo:load', this.updateControl)
  }

  disconnect() {
    this.element.removeEventListener('focus', this.onFocus, true)
    this.element.removeEventListener('blur', this.onBlur, true)

    document.removeEventListener('turbo:morph', this.updateControl)
    document.removeEventListener('turbo:load', this.updateControl)
  }

  onFocus = () => {
    this.patternMask.updateOptions({ lazy: false })
  }

  onBlur = () => {
    if (this.patternMask.unmaskedValue.length === 1) {
      this.patternMask.updateOptions({ lazy: true })
      this.patternMask.value = ''
    }
  }

  // Update the masked input when the page is loaded
  updateControl = () => {
    this.patternMask.updateControl()
  }

  // Update the masked input when the element is morphed
  updateMaskValue = () => {
    this.patternMask.updateValue()
  }
}
